// extracted by mini-css-extract-plugin
module.exports = {"submit":"Form_submit__3jS3S"};